import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellAddOnsHeader = (props: UpsellAddOnsHeaderProps) => {
  const { size, children } = props;

  const containerStyle = [
    styles.container,
    size === 'lg' ? styles.containerLG : styles.containerMD,
  ];

  return <View style={containerStyle}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  containerMD: {
    paddingBottom: theme.spacing['8'],
  },
  containerLG: {
    paddingBottom: theme.spacing['10'],
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellAddOnsHeaderProps = PropsWithChildren<{
  size: 'md' | 'lg';
}>;
